import React, {useContext} from "react";
import FormSwitcher from "./components/FormSwitcher";
import ClaimForm from "./pages/ClaimForm";
import ServisForm from "./pages/ServisForm";
import {GlobalContext} from "./context/GlobalProvider";

const App = () => {
    const {
        state: {
            formType
        }
    } = useContext(GlobalContext);

    return (
        <div className="bg-black-full px-4 pt-12 pb-16 text-white lg:!p-16">
            <div className="flex flex-col lg:flex-row lg:gap-12 mx-auto">

                <div className="w-full lg:w-1/2 p-0 md:pr-32">
                    <div className="flex flex-col gap-6">
                        <h2 className="font-28 mb-4">Schreiben Sie uns eine Nachricht</h2>
                        <p className="text-18 letter-spacing-4per line-height-150 text-neutrals-400 font-light">
                            Füllen Sie das Anfrageformular aus und bald wird sich unser Profirol-Experte bei Ihnen melden,
                            der Sie beraten und wichtige technische Parameter durchgehen wird. Jetzt brauchen wir nur die
                            notwendigsten Informationen, es dauert nur eine Minute.
                        </p>
                    </div>

                    <div className="pt-35px mt-45px border-t border-neutrals-700 mb-4">
                        <p className="mb-4 text-neutrals-400 text-16">Kontaktieren Sie uns</p>

                        <p className="mb-1 text-18 font-light text-white">Hotline</p>
                        <div className="flex flex-col lg:flex-row lg:items-center gap-6 mb-1">
                            <a href={`tel:${window.company_phone}`} className="flex items-center gap-2">
                                <img src='/images/icon_phone-empty.png' alt="phone" className="w-6 h-6" />
                                <p className="text-24">{window.company_phone}</p>
                            </a>

                            <a href={window.company_whatsapp} className="flex items-center gap-2">
                                <img src='/images/socials/icon_whatsapp.png' alt="whatsapp" className="w-6 h-6" />
                                <p className="text-whatsapp text-24">WhatsApp</p>
                            </a>
                        </div>

                        <p className="mb-7 text-neutrals-400 text-12 letter-spacing-2per line-height-130">(Mo-Fr:
                            9:00&nbsp;–&nbsp;17:00 Uhr)</p>
                        <a href={`mailto:${window.company_email}`}><p className="mb-7 headline-6">{window.company_email}</p></a>

                        <div className="flex gap-4">
                            <a href={window.company_facebook} target="_blank" rel="noopener noreferrer">
                                <img src='/images/socials/fb-400.svg' alt="Facebook" />
                            </a>
                            <a href={window.company_instagram} target="_blank" rel="noopener noreferrer">
                                <img src='/images/socials/ig-400.svg' alt="Instagram" />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="w-full lg:w-1/2 space-y-6 text-white product-form-placeholder">
                    <div className="contact-form__wrapper">
                        <div className="contact-form__xx col-span-full mx-auto relative">
                            <FormSwitcher />
                            {formType === 'claim' &&
                                <ClaimForm />
                            }

                            {formType === 'servis' &&
                                <ServisForm />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default App;
